module.exports = __webpack_public_path__ + "img/austin-pool.f804e692.webp";